// BonBoZ: chọn banner thông báo đẩy nào hiện trên dashboard. Đây là chỗ DUY
// NHẤT quyết định; `PushHealthBanner` và `NotificationPermissionBanner` chỉ
// đọc kết quả, nên không bao giờ có hai banner cùng nhắc một việc.
import { computed } from 'vue';
import { getDeviceType } from './deviceIdentity';
import { isPushSupported } from './pushHelper';
import { devicePushState } from './pushDeviceState';
import { pushHealth } from './pushHealth';
import { isReconnecting } from './pushRecovery';

export const PUSH_BANNER = {
  HEALTH: 'health',
  PERMISSION: 'permission',
};

const NO_BANNER = { banner: null, status: null, enableHere: false };

// Mọi quyền khác 'granted' đều coi là bị chặn, giống server
// (`Bonboz::PushDevice#reported_status`): iOS có thể báo 'default' sau khi
// chặn trong Cài đặt. 'unsupported' (tab Safari iPhone) là chuyện cài app.
const isBlockedLocally = permission =>
  permission !== 'granted' && permission !== 'unsupported';

const isEnabledHere = ({ permission, hasSubscription }) =>
  permission === 'granted' && hasSubscription !== false;

// Thứ tự ưu tiên, mỗi lúc chỉ MỘT banner:
// 1. Máy này là điện thoại và có vấn đề — quyền tại máy khác 'granted' (hiện
//    ngay, không chờ server), hoặc server báo khác 'ok' → banner sức khoẻ về
//    chính máy này, kèm nút sửa khi sửa được. App đang tự kết nối lại cho máy
//    này thì báo 'reconnecting' (không nút) thay cho vấn đề server báo.
// 2. Không thì, server báo điện thoại không nhận được (khác 'ok') → banner sức
//    khoẻ nhắc mở BonBoZ trên điện thoại; máy tính này chưa bật mà bật được
//    (và không đang tự kết nối lại) thì thêm nút phụ "Bật trên máy tính này".
// 3. Không thì (điện thoại ổn) → dải nhắc cũ, tự xét quyền trình duyệt máy này.
// Chưa tải được tình trạng điện thoại thì chưa hiện gì, trừ trường hợp 1.
export const resolvePushBanner = ({
  deviceType,
  permission,
  hasSubscription,
  health,
  pushSupported,
  reconnecting = false,
}) => {
  const serverStatus = health?.status;
  const isPhone = deviceType === 'phone';

  if (isPhone && isBlockedLocally(permission)) {
    // Chưa hỏi quyền bao giờ và server chưa thấy điện thoại nào: là "chưa bật"
    // (có nút bật) chứ không phải "đang chặn".
    const isNeverAsked =
      permission === 'default' && serverStatus === 'never_registered';
    return {
      banner: PUSH_BANNER.HEALTH,
      status: isNeverAsked ? 'never_registered' : 'blocked',
      enableHere: false,
    };
  }
  if (!serverStatus) return NO_BANNER;
  if (serverStatus !== 'ok') {
    return {
      banner: PUSH_BANNER.HEALTH,
      status: isPhone && reconnecting ? 'reconnecting' : serverStatus,
      enableHere:
        !isPhone &&
        !reconnecting &&
        pushSupported &&
        !isEnabledHere({ permission, hasSubscription }),
    };
  }
  return { banner: PUSH_BANNER.PERMISSION, status: 'ok', enableHere: false };
};

// Loại máy và khả năng push không đổi trong phiên nên đọc một lần.
export const usePushBanner = () => {
  const deviceType = getDeviceType();
  const pushSupported = isPushSupported();
  return computed(() =>
    resolvePushBanner({
      deviceType,
      pushSupported,
      permission: devicePushState.value.permission,
      hasSubscription: devicePushState.value.hasSubscription,
      health: pushHealth.value,
      reconnecting: isReconnecting.value,
    })
  );
};
